import ListMap from '../core/ListMap';
import MetaOption from './MetaOption';

class MetaOptionList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({ ...args, data: data.map(v => new MetaOption({ ...args, data: v })) });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaOption({ data: { id: key } });
  }

  // merge(otherList) {
  //   return this._mergeWithReplace(otherList);
  // }
}

export default MetaOptionList;
